(() => {
  function initArticleViewToggles(root = document) {
    root.querySelectorAll('[data-gl-article-view-toggle]').forEach((button) => {
      if (button.dataset.glInitialized === 'true') return;

      const article = button.closest('.article-template');
      const summary = article?.querySelector('[data-gl-ai-summary-content]');
      const content = article?.querySelector('.article-template__content:not([data-gl-ai-summary-content])');
      const summaryLabel = button.querySelector('[data-gl-label-summary]');
      const articleLabel = button.querySelector('[data-gl-label-article]');

      if (!article || !summary || !content || !summaryLabel || !articleLabel) return;

      content.insertAdjacentElement('afterend', summary);
      button.dataset.glInitialized = 'true';

      const setView = (view) => {
        const showSummary = view === 'summary';

        content.hidden = showSummary;
        summary.hidden = !showSummary;
        summaryLabel.hidden = showSummary;
        articleLabel.hidden = !showSummary;
        button.dataset.view = showSummary ? 'summary' : 'article';
        button.setAttribute(
          'aria-label',
          showSummary ? 'Teljes cikk megjelenítése' : 'AI technikai kivonat megjelenítése'
        );
      };

      button.addEventListener('click', () => {
        setView(button.dataset.view === 'summary' ? 'article' : 'summary');
      });

      setView('article');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initArticleViewToggles());
  } else {
    initArticleViewToggles();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initArticleViewToggles(event.target);
  });
})();
